import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  $('input:radio[read_only_input="true"]').parent().addClass('no-pointer-events')

  $('.grouped_radiobutton').click(function () {
    if ($(this).attr('read_only_input') === 'true') {
      return false
    }

    const groupId = $(this).attr('group_id')

    $(`input:radio[group_id=${groupId}]`).prop('checked', false)
    if (!this.removeChecked) {
      $(this).prop('checked', true)
    } else {
      this['remove-checked'] = false
    }
    return true
  })

  $('label:has(input[type=radio])').on('mousedown', function () {
    const radioBtn = $(this).find('input[type=radio]')
    if (radioBtn.attr('read_only_input') === 'true') {
      return false
    }

    const checked = radioBtn.prop('checked')
    radioBtn[0].removeChecked = checked
    return true
  })
})
